"use client";

import clsx from "clsx";
import React from "react";
import {useTranslation} from "react-i18next";
import type {MessageContentBuildWorkflow} from "@/services/wingman";
import Icon, {ICON_SIZES} from "../library/Icon";
import FileBubbleFrame from "./ask-file-bubble/FileBubbleFrame";

/** Read-only workflow request preserved in legacy conversation history. */
const AskWorkflowBuilderBubble: React.FC<{
   isUser?: boolean;
   agentName?: string;
   brandOverride?: string;
   className?: string;
   buildWorkflow: MessageContentBuildWorkflow;
   isLastInGroup?: boolean;
   hideAgentHeader?: boolean;
}> = ({
   isUser,
   agentName,
   brandOverride,
   className,
   buildWorkflow,
   isLastInGroup = true,
   hideAgentHeader = false,
}) => {
   const {t} = useTranslation("ask");
   const {workflow} = buildWorkflow;
   const title = workflow.suggestedName?.trim() || workflow.description;
   const description = workflow.description.trim();
   const showDescription = description.length > 0 && description !== title;

   return (
      <FileBubbleFrame
         isUser={isUser}
         agentName={agentName}
         brandOverride={brandOverride}
         className={className}
         isLastInGroup={isLastInGroup}
         hideAgentHeader={hideAgentHeader}
      >
         <div
            className={clsx(
               "group relative block overflow-hidden rounded-xl border border-300",
               "bg-panel w-full max-w-[620px]"
            )}
         >
            <div className="flex items-center gap-3 px-4 py-3">
               <div className="flex items-center justify-center w-9 h-9 rounded-lg bg-primary/10 text-primary flex-shrink-0">
                  <Icon icon="diagram-project" size={ICON_SIZES.SM} />
               </div>
               <div className="flex-1 min-w-0">
                  <p className="font-medium text-900 text-sm truncate" title={title}>
                     {title}
                  </p>
                  <p className="text-[10px] text-500 uppercase tracking-wide mt-0.5">
                     {t("workspace.buildWorkflow.badge")}
                  </p>
               </div>
            </div>

            {showDescription && (
               <p className="px-4 -mt-1 pb-3 text-xs text-500 line-clamp-3">{description}</p>
            )}
         </div>
      </FileBubbleFrame>
   );
};

export default AskWorkflowBuilderBubble;
